import { MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export function SupportButton() {
  return (
    <div className="fixed bottom-6 right-6 z-50">
      <Button
        asChild
        size="lg"
        className="h-14 w-14 rounded-full shadow-lg hover:shadow-xl transition-shadow"
      >
        <a href="/support" aria-label="Support">
          <MessageCircle className="h-6 w-6" />
        </a>
      </Button>
    </div>
  );
}
